import { type CSSProperties, memo, type ReactNode } from 'react';

import { cn } from '@air/utils-tailwind';

import { TableCell } from '~/components/TableView/TableCell';

type SortableHeaderProps = {
  title: string;
  className?: string;
  style?: CSSProperties;
  resizeHandle?: ReactNode;
};

export const StaticHeader = memo(({ title, className, resizeHandle, ...props }: SortableHeaderProps) => (
  <TableCell className={cn('p-1.5 px-2', className, !!resizeHandle && 'relative')} {...props}>
    <div className="group flex h-8 items-center justify-start border-0 bg-transparent py-0 font-semibold ads:text-secondary text-12 text-gray-11">
      <div className="truncate">{title}</div>
    </div>
    {resizeHandle}
  </TableCell>
));

StaticHeader.displayName = 'StaticHeader';
